var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper-title"},[_c('h2',{staticStyle:{"font-size":"13px","letter-spacing":".25px"}},[_vm._v("\n        "+_vm._s(_vm.title)+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }